import React from "react";
import { useParams } from "react-router-dom";
import "./central-committee.css";

import Template from "./Template/Template";
import TemplateDetail from "./Template/TemplateDetail";

export default function CentralCommittee() {
  const { id } = useParams();

  return (
    <>
      <div className="central-header">
        <h2 className="central-title">중앙운영위원회</h2>
      </div>

      {id ? <TemplateDetail /> : <Template />}
    </>
  );
}